import React, {
  useState,
  useEffect,
  useMemo,
  useRef,
  useCallback,
  Fragment,
} from 'react';
import { FaArrowCircleLeft } from 'react-icons/fa';
import { FiArrowLeftCircle, FiArrowLeft } from 'react-icons/fi';
import { useLocation, useParams } from 'react-router-dom';
import { useHistory } from 'react-router-dom';

import {
  Box,
  Text,
  Container,
  Image,
  Flex,
  IconButton,
} from '@chakra-ui/react';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import { set } from 'lodash';
import queryString from 'query-string';

import logoImg from '~/assets/logo-form.png';
import InputChakra from '~/shared/components/InputChakra';
import CheckboxInput from '~/shared/components/InputChakra/CheckboxChakra';
import SelectChakra from '~/shared/components/InputChakra/SelectChakra';
import LoadingAbsolute from '~/shared/components/LoadingAbsolute';
import SectionHeader from '~/shared/components/SectionHeader';
import api from '~/shared/services/api';
import { phoneMask } from '~/utils/mask';

interface ImmersionTaxReform {
  immersion_tax_reform: {
    id: number;
    user_id: number;
    responsility_id: number;
    tributary_regime_id: number;
    survey_id: number;
    name: string;
    email: string;
    phone: string;
    company_name: string;
    branch_activity: string;
    created_at: string;
    updated_at: string;
  };
}

interface SurveyOptions {
  id: number;
  name: string;
  label: string;
  value: string;
  visible?: boolean;
}

interface Filters {
  tributary_regimes: SurveyOptions[];
  responsibilities: SurveyOptions[];
}

interface Params {
  userId: string;
}

const ViewImmersionTaxReform: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const [loadingData, setLoadingData] = useState(true);
  const [loadingFilters, setLoadingFilters] = useState(true);

  const [dataTaxReform, setDataTaxReform] = useState<ImmersionTaxReform>();
  const history = useHistory();

  const { userId } = useParams<Params>();

  const [responsibilitiesTypes, setResponsibilitiesTypes] = useState<
    SurveyOptions[]
  >([]);
  const [tributaryRegimeTypes, setTributaryRegimeTypes] = useState<
    SurveyOptions[]
  >([]);

  const location = useLocation();
  const queryParams = useMemo(() => {
    return queryString.parse(location.search);
  }, [location.search]);

  /*   const goLink = useMemo(() => {
    return `/questionarios/holding/usuarios?t=${queryParams.t}`;
  }, [queryParams.t]); */
  const getData = useCallback(() => {
    setLoadingData(true);
    api
      .get<ImmersionTaxReform>(`/survey/immersion-tax-reform/users/${userId}`)
      .then((response) => {
        const { immersion_tax_reform } = response.data;
        // setSurvey(data);
        setDataTaxReform(response.data);

        // console.log(data.survey.token, data.id);
      })

      .finally(() => setLoadingData(false));
  }, [userId]);

  const getSelect = useCallback(() => {
    setLoadingFilters(true);
    api
      .get<Filters>(`/survey/filters`)

      .then((response) => {
        const { tributary_regimes, responsibilities } = response.data;
        setTributaryRegimeTypes(
          tributary_regimes.map((tr) => {
            return { ...tr, label: tr.name, value: tr.id.toString() };
          }),
        );
        setResponsibilitiesTypes(
          responsibilities.map((r) => {
            return { ...r, label: r.name, value: r.id.toString() };
          }),
        );
      })
      .finally(() => setLoadingFilters(false));
  }, []);

  useEffect(() => {
    getSelect();
    getData();
  }, [getData, getSelect]);

  const handleGoBack = useCallback(() => {
    history.goBack();
  }, [history]);

  return (
    <Container pos="relative">
      {loadingData && loadingFilters && (
        <LoadingAbsolute z_index={1111} min_height={500} />
      )}
      {!loadingData && !loadingFilters && (
        <>
          <Box display="flex" alignItems="center">
            <IconButton
              aria-label="Voltar"
              icon={<FiArrowLeft />}
              size="lg"
              borderRadius="md"
              ml={3}
              mt={3}
              onClick={handleGoBack}
              border="2px solid #4e545e"
              // borderColor="black"
            />
            <Text ml={3} mt={3}>
              Voltar
            </Text>
          </Box>

          <Box marginTop="20px">
            <Image
              width="100%"
              objectFit="contain"
              src={logoImg}
              alt="MyIPAC"
              mb={10}
            />
            <Flex justifyContent="center">
              <SectionHeader
                title={`Respondido por ${dataTaxReform?.immersion_tax_reform.name}`}
              />
            </Flex>
          </Box>

          <Form
            ref={formRef}
            onSubmit={() => ''}
            initialData={{
              tributary_regimes: tributaryRegimeTypes.map((rea) =>
                rea.id.toString(),
              ),
            }}
          >
            <Box>
              <Container
                backgroundColor="#fff"
                border="1px solid rgb(218,220,224)"
                borderRadius="8px"
                position="relative"
                paddingTop="22px"
                padding="24px"
                marginBottom="12px"
                marginTop="12px"
              >
                <Flex justifyContent="center">
                  <Text marginBottom="10px" fontSize="4xl">
                    Dados Pessoais
                  </Text>
                </Flex>

                <InputChakra
                  name="name"
                  label="Nome"
                  background="#e9ecef"
                  borderColor=""
                  mb="0px"
                  value={dataTaxReform?.immersion_tax_reform.name}
                  readOnly
                />
                <InputChakra
                  name="email"
                  label="E-mail"
                  background="#e9ecef"
                  borderColor=""
                  mb="0px"
                  value={dataTaxReform?.immersion_tax_reform.email}
                  readOnly
                />
                <InputChakra
                  name="phone"
                  label="Telefone"
                  background="#e9ecef"
                  borderColor=""
                  mb="0px"
                  value={phoneMask(
                    dataTaxReform?.immersion_tax_reform.phone || '',
                  )}
                  mask="phone"
                  readOnly
                />
              </Container>

              <Box>
                <>
                  <Container
                    backgroundColor="#fff"
                    border="1px solid rgb(218,220,224)"
                    borderRadius="8px"
                    position="relative"
                    paddingTop="22px"
                    padding="24px"
                    marginBottom="12px"
                    marginTop="12px"
                  >
                    <Flex justifyContent="center">
                      <Text fontSize="4xl" marginBottom="10px">
                        Empresa
                      </Text>
                    </Flex>

                    <InputChakra
                      name="company_name"
                      label="Nome da Empresa"
                      background="#e9ecef"
                      borderColor=""
                      mb="0px"
                      value={dataTaxReform?.immersion_tax_reform.company_name}
                      readOnly
                    />

                    <InputChakra
                      name="branch_activity"
                      label="Ramo de Atividade"
                      background="#e9ecef"
                      borderColor=""
                      mb="0px"
                      value={
                        dataTaxReform?.immersion_tax_reform.branch_activity
                      }
                      readOnly
                    />

                    <SelectChakra
                      name="tributary_regime_id"
                      label="Regime Tributário"
                      background="#e9ecef"
                      borderColor=""
                      mb="0px"
                      options={tributaryRegimeTypes}
                      // placeholder="Selecione"
                      value={
                        dataTaxReform?.immersion_tax_reform.tributary_regime_id
                      }
                      disabled
                    />
                    <SelectChakra
                      name="responsibility_id"
                      label="Cargo"
                      background="#e9ecef"
                      borderColor=""
                      mb="0px"
                      options={responsibilitiesTypes}
                      // placeholder="Selecione"
                      value={
                        dataTaxReform?.immersion_tax_reform.responsility_id
                      }
                      disabled
                    />
                  </Container>
                </>
              </Box>
            </Box>
          </Form>
        </>
      )}
    </Container>
  );
};

export default ViewImmersionTaxReform;
